module.exports = __webpack_public_path__ + "static/media/hero-mobile@2x.50341ab3.jpg";